import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { CSSProperties } from 'vue'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons'

interface SlotActionsReturn {
  isOpen: Ref<boolean>
  containerRef: Ref<HTMLElement | null>
  floatingRef: Ref<HTMLElement | null>
  floatingStyles: Ref<CSSProperties>
  triggerIcon: IconDefinition
  toggle: () => void
  openAction: (href: string) => void
}

export const useSlotActions = (): SlotActionsReturn => {
  const isOpen = ref(false)
  const containerRef = ref<HTMLElement | null>(null)
  const floatingRef = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(containerRef, floatingRef, {
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      shift({ padding: 8 }),
    ],
  })

  const toggle = (): void => {
    isOpen.value = !isOpen.value
  }

  const openAction = (href: string): void => {
    isOpen.value = false
    if (typeof window !== 'undefined') {
      window.open(href, '_blank', 'noopener,noreferrer')
    }
  }

  onClickOutside(containerRef, () => {
    isOpen.value = false
  })

  return {
    isOpen,
    containerRef,
    floatingRef,
    floatingStyles,
    triggerIcon: faEllipsisVertical,
    toggle,
    openAction,
  }
}
